import React, { useState, useEffect, useRef } from 'react';
import { Drawer } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { ChromePicker } from 'react-color';
import { SwatchesPicker } from 'react-color';
import ComFunction from "../components/ComFunction";
import { useSelector } from "react-redux";
import { isEmpty } from '../modules/appLibrary';

//---------------------------------------------------------------------
//  ColorPicker
//---------------------------------------------------------------------
export default function ColorPicker(props) {
    const fnc = useRef();
    const ComFunc = React.forwardRef(ComFunction);

    const open = useSelector(state => state.search.colorpickeropen);
    const label = useSelector(state => state.search.label);
    const datainfo = useSelector(state => state.search.data);
    const rowid = useSelector(state => state.search.rowid);
    const doApply = useSelector(state => state.search.doApply);
    const gridApi = useSelector(state => state.search.gridApi);
    const [show, setshow] = useState(false)
    const [value, setValue] = React.useState('#fff');

    useEffect(() => {
        setshow(open);
    }, [open])

    useEffect(() => {
        if (!open) return;
        if (rowid.length > 1 && !isEmpty(gridApi)) {
            //選択行保持
            for (let i = 0; i < rowid.length; i++) {
                let rowNode = gridApi.getRowNode(rowid[i]);
                rowNode.setSelected(true);
            }
        }
    }, [rowid])

    function Apply() {
        let data = {
            key: datainfo.columnid,
            value: value,
            rowid: rowid,
            datainfo: datainfo
        };
        doApply(data, 0)
    }
    function onChange(color) {
        setValue(color.hex);
    }

    function onHandleClose() {
        fnc.current.searchlistclose();
    };

    return (
        <div>
            <Drawer anchor={"right"} open={show} onClose={onHandleClose} BackdropProps={{ invisible: true }}>
                <div style={{ marginRight: 10 }}>
                    <div style={{ textAlign: 'left', float: 'left', marginTop: 10, marginLeft: 10 }}>
                        <span >{ label}</span>
                    </div>
                    <div style={{ textAlign: 'right', marginTop: 10 }} >
                        <Button variant="outlined" size="small" onClick={Apply}>適用</Button>
                        <Button variant="outlined" size="small" onClick={onHandleClose}>中止</Button>
                    </div>
                </div>
                <div style={{ display: 'flex', width: 600, padding: 20, backgroundColor:value }}>
                    <div style={{flex:1}}>
                        <SwatchesPicker height={600} onChange={onChange}/>
                    </div>
                    <div>
                        <ChromePicker
                            color={value}
                            onChangeComplete={onChange}
                        />
                    </div>
                </div>
            </Drawer>
            <ComFunc ref={fnc} />
        </div>
    );
};
